// src/com/home/TopHome.js
import React, { useState, useEffect, useRef } from 'react';
import { styled  } from '@mui/material/styles';
import CachedIcon from '@mui/icons-material/Cached'; // refresh
import { TopContainer, TopHeader, TopContent } from '../../common/TopStyle';
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { currentPlanStatWithRentListRepo, userInfoRepo } from '../../value/AppModel';
import {
    CurrentPlanStateColumns, LIST_CURRENT_PLAN_STAT_WITH_RENT, makeCurrantPlanStateTree
} from '../current_plan_stat_with_rent/CurrentPlanStatWithRentGql';
import { AppObject, AppStyle, AppWord } from '../../value/AppConst';
import { useAlertSetter } from '../../api/app-hook';
import { useSnackbar } from 'notistack';
import ValueMisc from '../../value/ValueMisc';
import { CircularProgress, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';


const TypeColor = {
    A: AppStyle.PrimaryRGB, // 상온
    F: AppStyle.SuccessRGB, // 냉장
    E: AppStyle.WarnRGB, // Expres
};

const HeaderCell = styled(TableCell)({
    paddingLeft:0, paddingRight:0, textAlign: 'center', fontSize: '0.85rem',
});

const StateLabel = ({label, bgColor}) => {
    const nameFore2 = label.substring(0, 2);
    const nameRest = label.substring(2);

    return(
        <HeaderCell style={{backgroundColor: bgColor}}>
            <div>{nameFore2}</div>
            <div>{nameRest}</div>
        </HeaderCell>
    )
};

const ValueCell = styled(TableCell)({textAlign: 'center'});

export default function TopHome() {
    const sessionInfo = useReactiveVar(userInfoRepo);
    const currentPlanStatWithRentListData = useReactiveVar(currentPlanStatWithRentListRepo);
    const [treeAndTotal, setTreeAndTotal] = useState({tree:[], total:{}});
    const [timeLabel, setTimeLabel] = useState('');
    const addAlert = useAlertSetter();
    const { enqueueSnackbar } = useSnackbar();
    const lastReloadRef = useRef(0);

    // ##### Call GraphQL to get List #####
    const [getCurrentPlanStatWithRentList, responseList] = useLazyQuery(LIST_CURRENT_PLAN_STAT_WITH_RENT, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetStatList(data, option)},
		onError: (error) => addAlert({title: '현황정보 조회 오류', message: [error.message]})
    });

    // find menuUrl: "TAB_Bbs"
    // find parent: menuUrl: "NM_BBS"
    useEffect(() => {
        if(sessionInfo.isHomeplusOrEtrace()) {
            const diff = new Date().getTime()/1000 - currentPlanStatWithRentListData.when;
            if(diff > 60) // || currentPlanStatWithRentListData.records.length === 0)
                getCurrentPlanStatWithRentList();
        }
    }, [sessionInfo]);

    useEffect(() => {
        if(currentPlanStatWithRentListData.records.length > 0) {
            const newData = makeCurrantPlanStateTree(currentPlanStatWithRentListData.records);
            setTreeAndTotal(newData);
            /* const pieTree = {};
            newData.tree.forEach((subTree)=>{
                pieTree[subTree.dcTypeCd] = {
                    dcTypeCd:subTree.dcTypeCd,
                    dcTypeName:subTree.dcTypeName,
                    dcList:[]
                };
                subTree.dcList.forEach((dcRec)=>{
                    const pieData = CurrentPlanStateColumnsForChart.map((field)=>{
                        return {name:field.label, value:dcRec[field.valueKey]};
                    })

                    pieTree[subTree.dcTypeCd].dcList.push({
                        dcCd: dcRec.dcCd,
                        dcLabel: dcRec.dcLabel,
                        pieData: pieData,
                    });
                })
            }); */
        }
    }, [currentPlanStatWithRentListData]);

    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    const onCompleteGetStatList = (data, clientOption) => {
        if(data.currentPlanStatWithRentList) {
            const now = new Date();
            currentPlanStatWithRentListRepo({when:now.getTime()/1000, records:data.currentPlanStatWithRentList});
            lastReloadRef.current = now.getTime() / 1000;
            setTimeLabel(`${now.getHours()}:${now.getMinutes()}`);
        }
    };

    const onClickReload = () => {
        const diff = new Date().getTime()/1000 - lastReloadRef.current;
        if(diff < 10) {
            // Too short to reload
            enqueueSnackbar('10초 이내 재조회는 삼가해 주세요', {variant:'info', autoHideDuration:1500});
        }
        else getCurrentPlanStatWithRentList();
    };


    const renderDcTypeRows = (subTree) => {
        return (
            <>
            {
                subTree.dcList.map((dcRec, index) => {
                
                    const bgColor = index % 2 === 0 ? '#eee' : '#fff';
                    return(
                        <TableRow key={dcRec.dcCd}>
                            {
                                index === 0 &&
                                <TableCell
                                    style={{
                                        backgroundColor: TypeColor[subTree.dcTypeCd],
                                        color: 'white', fontSzie: '0.85rem',
                                        borderRight: '1px solid white',
                                        paddingLeft:0, paddingRight:0, textAlign: 'center',
                                    }}
                                    rowSpan={subTree.dcList.length}
                                >
                                    {subTree.dcTypeName==='Express' ? 'Exp' : subTree.dcTypeName}
                                </TableCell>
                            }
                            <TableCell
                                style={{
                                    backgroundColor: TypeColor[dcRec.dcTypeCd], color: 'white',
                                    paddingLeft:0, paddingRight:0, textAlign: 'center',
                                }}
                            >
                                {dcRec.dcLabel}
                            </TableCell>
                            <ValueCell style={{backgroundColor: bgColor}}>
                                {ValueMisc.int2str(dcRec.transRequest)}
                            </ValueCell>
                            <ValueCell style={{backgroundColor: bgColor}}>
                                {ValueMisc.int2str(dcRec.planned)}
                            </ValueCell>
                            <ValueCell style={{backgroundColor: bgColor}}>
                                {ValueMisc.int2str(dcRec.leftDc)}
                            </ValueCell>
                            <ValueCell style={{backgroundColor: bgColor}}>
                                {ValueMisc.int2str(dcRec.assignDc)}
                            </ValueCell>
                            <ValueCell style={{backgroundColor: bgColor}}>
                                {ValueMisc.int2str(dcRec.waitDc)}
                            </ValueCell>
                        </TableRow>
                    );
                })
            }
            </>
        );
        /* return (
            <TableRow key={subTree.dcTypeCd}>
                <TableCell rowSpan={subTree.dcList.length}>
                    {subTree.dcTypeName}
                </TableCell>
            </TableRow>
        ) */
    };

    const loadingAny = responseList.loading;

    return(
        <TopContainer>
            <TopHeader>
                현황판
            </TopHeader>
            <TopContent>
                <TableContainer component={Paper}>
                    <Table size={AppWord.SMALL}>
                        <TableBody>
                            <TableRow>
                                <HeaderCell colSpan={2}>
                                    {timeLabel}
                                    {
                                        loadingAny ?
                                        <CircularProgress size={20} />
                                        :
                                        <IconButton
                                            color={AppStyle.mui.inherit}
                                            onClick={onClickReload}
                                        >
                                            <CachedIcon />
                                        </IconButton>
                                    }
                                </HeaderCell>
                                {
                                    CurrentPlanStateColumns.map((col) => {
                                        return(
                                            <StateLabel bgColor={col.color} label={col.label}
                                                key={col.valueKey}/>
                                        );
                                    })
                                }
                            </TableRow>
                            {
                                treeAndTotal.tree.map((subTree) => {
                                    return renderDcTypeRows(subTree);
                                })
                            }
                            <TableRow style={{backgroundColor: '#ccc'}}>
                                <TableCell colSpan={2} style={{textAlign: 'center', fontWeight: 'bold'}}>
                                    Total
                                </TableCell>
                                <ValueCell>
                                    {ValueMisc.int2str(treeAndTotal.total.transRequest || 0)}
                                </ValueCell>
                                <ValueCell>
                                    {ValueMisc.int2str(treeAndTotal.total.planned || 0)}
                                </ValueCell>
                                <ValueCell>
                                    {ValueMisc.int2str(treeAndTotal.total.leftDc || 0)}
                                </ValueCell>
                                <ValueCell>
                                    {ValueMisc.int2str(treeAndTotal.total.assignDc || 0)}
                                </ValueCell>
                                <ValueCell>
                                    {ValueMisc.int2str(treeAndTotal.total.waitDc || 0)}
                                </ValueCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </TopContent>
        </TopContainer>
    );
}